// extracted by mini-css-extract-plugin
export default {"loadingInput":"MenuLoadingSkeleton-MenuLoadingSkeleton-module__loadingInput--mV8jg","loadingContainer":"MenuLoadingSkeleton-MenuLoadingSkeleton-module__loadingContainer--I6sLW"};